module.exports = __webpack_public_path__ + "img/tj.c8b3c494.svg";